import { render } from "./UefaUpcomingListWidget.vue?vue&type=template&id=5664cbaf&ts=true"
import script from "./UefaUpcomingListWidget.vue?vue&type=script&lang=ts"
export * from "./UefaUpcomingListWidget.vue?vue&type=script&lang=ts"

import "./UefaUpcomingListWidget.vue?vue&type=style&index=0&id=5664cbaf&lang=scss"

import exportComponent from "/home/node/app/.yarn/__virtual__/vue-loader-virtual-2429a647ea/0/cache/vue-loader-npm-17.0.0-6ebaa2d3c5-0c0a647a4e.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__